import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';


class SmartCity extends React.Component{
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
    Smart City Major Projects Partner
    </Header>
    <Divider/>
      <p>
        JK Asset Management, a UK company, is a BIM and digital twin consultancy firm. The firm
        works with large global organizations, public infrastructure builders, and asset management
        companies to achieve construction efficiency and to minimize time and cost overruns using
        multi-dimensional digital transformation technologies. The founder, T. Karthikeyan, B.E.,
        MSc Major Programme Management (Oxford), MIAM, Dip Asset Management, is an Oxford cohort with several OVC co-
        founders. Together with OVC, the team has collaborated on smart city major projects.
      </p>
    </Container>;
  }
}

export default SmartCity;
